<template>
    <div v-if="connection" class="">
        SSO Connection: {{ connection.strategy }}
    </div>

    <form v-if="!connection" @submit.prevent="form.episode('/accounts/' + account.uuid)">
        <label>
            Google Workspace Domain
            <input type="text" v-model="form.domain">
        </label>
        <div v-if="form.errors.domain">{{ form.errors.domain }}</div>

        <label>
            Client ID
            <input type="text" v-model="form.clientId">
        </label>
        <div v-if="form.errors.clientId">{{ form.errors.clientId }}</div>

        <label>
            Client Secret
            <input type="text" v-model="form.clientSecret">
        </label>
        <div v-if="form.errors.clientSecret">{{ form.errors.clientSecret }}</div>

        <button type="submit" :disabled="form.processing">Add Google Workspace SSO Connection</button>
    </form>
</template>

<script>
    import { useForm } from '@inertiajs/inertia-vue3'
    import Modal from '@/Shared/Modal'
    import Button from '@/Shared/Button'
    import { ref } from 'vue'

    export default {
        setup() {
            const open = ref(false)

            const form = useForm({
                _method: 'patch',
                domain: null,
                clientId: null,
                clientSecret: null,
            })
            return { form, open  }
        },
        props: [ connection ],
    }

</script>
